import React, { useState, useEffect } from 'react';

const REGIMES = [
    { key: 'TRENDING_UP',     label: 'Tendência ↑',  hint: 'Alta — stop curto (ex: 0.97)' },
    { key: 'RANGING',         label: 'Lateral',       hint: 'Neutro — stop normal (ex: 0.98)' },
    { key: 'HIGH_VOLATILITY', label: 'Alta Vol.',     hint: 'Volátil — stop mais largo (ex: 0.93)' },
    { key: 'TRENDING_DOWN',   label: 'Tendência ↓',  hint: 'Baixa — muito largo (ex: 0.90)' },
];

const EMPTY = { TRENDING_UP: '', RANGING: '', HIGH_VOLATILITY: '', TRENDING_DOWN: '' };

/**
 * props:
 * - regimeStopMultiplier  (JSON string or null)
 * - onChange(event: { target: { id: 'regimeStopMultiplier', value: string|null } })
 */
function RegimeStopTemplate({ regimeStopMultiplier, onChange }) {
    const [enabled, setEnabled] = useState(false);
    const [values, setValues] = useState(EMPTY);

    useEffect(() => {
        if (regimeStopMultiplier) {
            try {
                const parsed = typeof regimeStopMultiplier === 'string' ? JSON.parse(regimeStopMultiplier) : regimeStopMultiplier;
                setValues({ ...EMPTY, ...parsed });
                setEnabled(true);
            } catch {
                setEnabled(false);
                setValues(EMPTY);
            }
        } else {
            setEnabled(false);
            setValues(EMPTY);
        }
    }, [regimeStopMultiplier]);

    function notify(newValues) {
        const hasAny = Object.values(newValues).some(v => v !== '' && v !== null);
        onChange({
            target: {
                id: 'regimeStopMultiplier',
                value: hasAny ? JSON.stringify(newValues) : null
            }
        });
    }

    function onToggle() {
        const next = !enabled;
        setEnabled(next);
        if (!next) {
            setValues(EMPTY);
            onChange({ target: { id: 'regimeStopMultiplier', value: null } });
        }
    }

    function onMultChange(key, raw) {
        const newValues = { ...values, [key]: raw };
        setValues(newValues);
        notify(newValues);
    }

    function impliedPct(val) {
        const n = parseFloat(val);
        if (!val || isNaN(n)) return null;
        return ((1 - n) * 100).toFixed(1);
    }

    return (
        <div className='row mt-2'>
            <div className='col-12 mb-2'>
                <div className='form-check form-switch'>
                    <input className='form-check-input' type='checkbox' id='regimeStopToggle'
                        checked={enabled} onChange={onToggle} />
                    <label className='form-check-label' htmlFor='regimeStopToggle'>
                        Stop Loss por Regime de Mercado
                    </label>
                    <small className='text-muted ms-2'>Substitui o multiplicador de stop pelo regime de mercado</small>
                </div>
            </div>
            {enabled && (
                <div className='col-12'>
                    <div className='row g-2'>
                        {REGIMES.map(r => {
                            const pct = impliedPct(values[r.key]);
                            return (
                                <div className='col-6 col-md-3' key={r.key}>
                                    <label className='form-label mb-1 small'>{r.label}</label>
                                    <input
                                        type='number'
                                        className='form-control form-control-sm'
                                        min='0.5'
                                        max='1'
                                        step='0.01'
                                        placeholder='—'
                                        value={values[r.key]}
                                        onChange={e => onMultChange(r.key, e.target.value)}
                                    />
                                    <small className='text-muted'>
                                        {pct !== null ? `−${pct}% from market` : r.hint}
                                    </small>
                                </div>
                            );
                        })}
                    </div>
                    <small className='text-muted mt-1 d-block'>
                        Multiplicador aplicado ao preço de mercado (ex: 0.97 = stop 3% abaixo). Vazio = usar padrão.
                    </small>
                </div>
            )}
        </div>
    );
}

export default RegimeStopTemplate;
